import type { Shape } from "@gettactic/map-builder/src/types";
import { useEditorSelector } from "./EditorStoreContext";

export const useShape = (id: string): Shape | undefined =>
  useEditorSelector((state) => state.shapes[id]);

export const useIsSelected = (id: string): boolean =>
  useEditorSelector((state) => state.selection.includes(id));

export const useSelection = (): string[] =>
  useEditorSelector((state) => state.selection);

export const useViewport = () => useEditorSelector((state) => state.viewport);

export const useEditorUi = () => useEditorSelector((state) => state.ui);

export const useActiveTool = () => useEditorSelector((state) => state.tool);

export const useDocumentMeta = () => useEditorSelector((state) => state.meta);

export const useOrder = (): string[] =>
  useEditorSelector((state) => state.order);
